angular
	.module('app.components', [])
	.component('albaToggle', {
		templateUrl: 'ng/components/albaToggle/albaToggle.html',
		bindings: {
			/** Required data **/
			user: '=?',
			/** Optional data **/
			textLeft: '@',
			textRight: '@',
			disabled: '<'
		},
		controllerAs: 'albaToggleCtrl',
		controller: function ($userService, $filter) {
			/** not to loose *this reference **/
			var self = this;

			self.$userService = $userService;

			self.flags = {
				blocked: false,
				enabled: false
			}

			self.$onInit = function () {
				console.log('initializing an alba-toggle component..', self);
				console.log('user passed: ', self.user);

				self.textLeft = self.textLeft || $filter('translate')('LBL_ON');
				self.textRight = self.textRight || $filter('translate')('LBL_OFF');

			}

			self.isBlocked = function () {
				if (self.user &&
					self.user.status == propMap['USER_STATUS_BLOCKED']) {
					return true;
				}
				return false;
			}

			self.blockUser = function () {
				self.$userService.blockAppUserAndChildren(self.user.identifier)
					.then(function (success) {
						success && console.log("user blocked successfully!");
						if (success) {
							self.flags.blocked = true;
							self.flags.enabled = false;
							self.user.status = propMap['USER_STATUS_BLOCKED'];
						}

					})

			}

			self.enableUser = function () {
				self.$userService.enableAppUser(self.user.identifier)
					.then(function (success) {
						success && console.log("user enabled successfully!");
						if (success) {
							self.flags.enabled = true;
							self.flags.blocked = false;
							self.user.status = propMap['USER_STATUS_ENABLED'];
						}
					})
			}



		}
	});